import {ICompany} from "../../../index";
import {Permission} from "../../../constants/Permission";

type IMutableCompany = {
    [Key in keyof ICompany]?: KnockoutObservable<ICompany[Key]>;
}

interface IMutableCard {
    discard: () => void
    dispose: () => void
    isActive: KnockoutObservable<boolean | null>
    isChanged: KnockoutComputed<boolean>
    isValid: KnockoutComputed<boolean>
}

interface IStatusDataParams {
    permission: KnockoutObservable<Permission>
}

type TCrudMode = 'read' | 'write'

type TSyncStatus = 'halted' | 'waiting' | 'executed' | 'executing' | 'unknown' | 'executedwitherrors'

type TBtnHeader = IDropdownButton & IButton
